"use client";

import { Building2, LoaderCircle, LogOut, Moon, Sun, User } from "lucide-react";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";

import { logout } from "@/app/actions";
import { useTheme } from "@/providers/theme";
import { useUserStore } from "@/stores/user";
import { useRouter } from "next/navigation";
import { getInitials } from "@/utils/utils";

export function NavUser() {
  const { isMobile, setOpenMobile } = useSidebar();
  const { theme, toggleTheme } = useTheme();
  const { user, isLoading } = useUserStore();
  const router = useRouter();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="max-h-8 data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground md:p-0"
            >
              <Avatar className="size-8 rounded-lg p-1">
                {isLoading ? (
                  <LoaderCircle className="flex size-4 flex-grow animate-spin self-center text-brand-primary" />
                ) : (
                  <>
                    {" "}
                    <AvatarImage
                      src={user?.avatar ? `/avatars/${user.avatar}` : ""}
                      alt={user?.name}
                    />
                    <AvatarFallback className="rounded-lg">
                      {getInitials(user?.name || "")}
                    </AvatarFallback>
                  </>
                )}
              </Avatar>
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={0}
            collisionPadding={8}
          >
            <DropdownMenuGroup>
              <DropdownMenuItem
                onClick={() => {
                  if (isMobile) setOpenMobile(false);
                  router.push("/settings/profile");
                }}
              >
                <User />
                My Profile
              </DropdownMenuItem>
              <DropdownMenuItem onClick={toggleTheme}>
                {theme === "dark" ? (
                  <>
                    <Sun />
                    Light Mode
                  </>
                ) : (
                  <>
                    <Moon />
                    Dark Mode
                  </>
                )}
              </DropdownMenuItem>
              <DropdownMenuItem
                onClick={() => {
                  if (isMobile) setOpenMobile(false);
                  router.push("/settings/organizations");
                }}
              >
                <Building2 />
                My Organizations
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="text-red-500 focus:text-red-500"
              onClick={(e) => {
                e.preventDefault();
                logout();
              }}
            >
              <LogOut />
              Sign out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
